export function getFilterValues(data) {
    const filterValues = {};
    data.forEach(filter => {
      filter.params.forEach(param => {
        filterValues[param.type] = param.value;
      });
    });
    return filterValues;
  }